




































































































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('Country', {
      countries: 'countries',
    }),
    ...mapState('Business', {
      business: 'business',
    }),
  },
})
export default class BusinessUpdateAddressNew extends Vue {
  @Prop({ default: () => ({}) }) businessAddress!: Model;
  @Prop() readonly businessOid!: string;
  @PropSync('showSheet') syncedShowSheet!: boolean;

  isLoading = false;
  isMounted = false;
  business!: Model;

  countries!: [
    {
      id: number;
      name: string;
      code: string;
      states: [];
    }
  ];

  async beforeMount() {
    this.$store
      .dispatch('Country/fetchList', {
        params: {
          expand: ['states'],
        },
      })
      .then(() => {
        this.businessAddress.country_id =
          this.countries.find(
            (country) => country.code == (this.business.country || 'AU')
          )?.id || this.countries.find((country) => country.code == 'AU')?.id;
        this.isMounted = true;
      });
  }

  get states() {
    if (!this.businessAddress.country_id) {
      return [];
    }
    const country = this.countries.find(
      (country) => country.id === this.businessAddress.country_id
    );
    return country ? country.states : [];
  }

  handleSubmitAddress() {
    this.isLoading = true;
    const action = this.businessAddress.object_id
      ? 'BusinessAddress/update'
      : 'BusinessAddress/create';
    this.$store
      .dispatch(action, {
        ...this.businessAddress,
        business_oid: this.businessOid,
      })
      .then(() => {
        this.$store
          .dispatch('Business/fetch', {
            businessOid: this.businessOid,
            config: {
              params: {
                expand: [
                  'business_contacts',
                  'business_addresses',
                  'billing_address',
                  'billing_contact',
                  'postal_address',
                  'primary_contact',
                  'director_contact',
                ],
              },
            },
          })
          .then(() => {
            this.isLoading = false;
            this.syncedShowSheet = false;
          });
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
